/**
 * created by wang lei
 通知公告-新增通知 页面
 *
 */
import React, {Component} from 'react';
import {Button, Icon, Input, Modal, Select, Upload, message} from "antd";
import Editors from "../../components/editor/Editors";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import {base64Encode, getSubffix, uuid} from "../../../utils";
import CandidateComponents from "../../components/treeModuleBySelectPerson/CandidateComponents";
import UploadWall from "../../../components/upload/UploadWall";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import {removeContentSecurity} from "../../editor/floatTool/securityCheck";
import {FILE_TYPE} from "../../../constants";
import NoticeUploadWall from "./noticeUploadWall";
import TreeModuleBySelectDept from "../../components/treeModuleBySelectDept/treeModuleBySelectDept";


const {Option} = Select;

export default class AddingNotices extends BaseComponent {
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            content: '',
            isUpDate: false,
            typeValue: 'all',
            status: 0,
            deptAndUserVisible: false,
            deptVisible: false,
            isDisplay: "none",
            sendFlag: false,
            newSelectList: [],
            newFileListPath: [],
            nameValue: [],
            receiveUserDeptIds: [],
            // receiveUserDeptNames:[],
            // 选中的人
            receiveUserDeptInfos: [],
            // 选中的部门
            receiveDeptInfos: [],
            treeModuleBySelectDeptKey: uuid(),
            data: [],
            newName:[]
        };
        this.chunkUpload = new ChunkUpload({
            checkFileURL: "/storage/checkFile",
            checkChunkURL: "/storage/checkChunk",
            uploadChunkURL: "/storage/uploadChunk",
            chunkUploadOverURL: "/storage/chunkIsUploadOver",
            mergeChunksURL: "/storage/mergeChunk"
        });
    }

    showModal = (item, storageFileList) => {
        if (item) {
            if(item?.deptRecipients?.length) {
                this.getDeptsInfo(item?.deptRecipients || [])
            }
            this.setState({
                inputValue: item.title,
                content: item.content,
                idValue: item.id,
                typeValue: item.type,
                nameValue: item.recipientsNames,
                isUpDate: true,
                visible: true,
                newSelectList: item.recipients,
                fileList: storageFileList,
                data: item,
                receiveDeptInfos: item?.deptRecipients || [],
                isDisplay: item.type == "users" || item.type == "depts" ? "block" : "none",
                userIdAndDeptIds:item.userIdAndDeptIds,
                receiveUserDeptInfos:item.receiveUserDeptInfos,
            }, () => {
                // if (this.state.typeValue == "users" || this.state.typeValue == "depts") {
                //     this.setState({isDisplay: "block"});
                // }
            })
        } else {
            this.setState({
                visible: true,
            });
        }
    };

    getDeptsInfo = (ids) => {
        if(ids && ids.length) {
            this.request({
                url: "/cm-sites-sys/dept/getByIds",
                method: "post",
                body: ids,
                contentType: "json",
                callBack: (res) => {
                    if(res && res.length) {
                        this.setState({receiveDeptInfos:res})
                    }
                },
                errorCallBack: (e) => {
                    console.log(e.toString())
                },
            })
        }
    };

    getParams = () => {
        let flag = this.checkParams();
        if (!flag) {
            return false;
        }
        // 组装数据
        let {typeValue, inputValue, idValue, status, content, newSelectList, sendFlag, fileList, nameValue, receiveUserDeptIds, receiveUserDeptInfos, receiveDeptInfos} = this.state;
        let newFileListPath = fileList && fileList.map((item) => item.path);
        // this.state.newFileListPath=newFileListPath;
        let newContent = base64Encode(removeContentSecurity(content));
        let params;
        switch (typeValue) {
            case "all" :
                params = {
                    notice: {
                        content: newContent,
                        title: inputValue,
                        type: typeValue,//部门类型
                        id: idValue,//修改时必填
                        status: status,//状态
                        attachements: newFileListPath ? newFileListPath : [],//公告附件集合

                        recipients: [],
                        receiveUserDeptInfos: [],
                        deptRecipients: [],
                        recipientsNames: [],
                        receiveRange:'all'
                    },
                    deptIdAndUserIds: [],
                    sendFlag: sendFlag,//是否发送通知公告
                    encryptType: "base64"
                };
                break;
            case "users" :
                params = {
                    notice: {
                        content: newContent,
                        title: inputValue,
                        type: typeValue,//部门类型
                        id: idValue,//修改时必填
                        status: status,//状态
                        attachements: newFileListPath ? newFileListPath : [],//公告附件集合

                        recipients: newSelectList,//公告接收者id
                        receiveUserDeptInfos: receiveUserDeptInfos,
                        deptRecipients: [],
                        recipientsNames: nameValue,
                        receiveRange:'users'
                    },
                    deptIdAndUserIds: receiveUserDeptIds,//部门id-接收者id
                    sendFlag: sendFlag,//是否发送通知公告
                    encryptType: "base64",
                };
                break;
            case "depts" :
                params = {
                    notice: {
                        content: newContent,
                        title: inputValue,
                        type: typeValue,//部门类型
                        id: idValue,//修改时必填
                        status: status,//状态
                        attachements: newFileListPath ? newFileListPath : [],//公告附件集合

                        recipients: [],//公告接收者id
                        receiveUserDeptInfos: [],
                        deptRecipients: receiveDeptInfos?.map(item => item.id) || [], // 选择的部门[""]
                        recipientsNames:[],
                        receiveRange:'depts'
                    },
                    deptIdAndUserIds: [],//部门id-接收者id
                    sendFlag: sendFlag,//是否发送通知公告
                    encryptType: "base64",
                };
                break;
        }
        // 返回数据
        return params
    };

    //发布
    getPublish = e => {
        this.state.status = 3;
        this.state.sendFlag = true;
        let params = this.getParams();
        if (params) {
            this.getSave(params)
        }
    };


    //暂存
    getHold = e => {
        let params = this.getParams();
        if (params) {
            this.getSave(params)
        }
    };

    handleCancel = e => {
        if (typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({visible: false})
    };

    render() {
        let {fileList} = this.state;
        let that=this
        return (
            <Modal
                title="新增通知"
                visible={this.state.visible}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={parseInt(document.body.clientWidth) > 1500 ? 1200 : parseInt(document.body.clientWidth) * 0.8}
                footer={
                    <div>
                        <Button onClick={() => {
                            this.state.fileList = this.NoticeUploadWall.getFillDown()
                            for (let i = 0; this.state.fileList && i < this.state.fileList.length; i++) {
                                let item = this.state.fileList[i];
                                if (item.uid) {//说明是刚上传的
                                    if (item.status != "done") {
                                        message.destroy()
                                        message.warn({content: `附件尚未上传完成！`});
                                        return;
                                    }
                                }
                            }
                            this.getReceiveUserDeptIds()
                            this.getHold()
                        }}
                        >暂存</Button>
                        <Button type="primary" onClick={() => {
                            this.state.fileList = this.NoticeUploadWall.getFillDown()
                            for (let i = 0; this.state.fileList && i < this.state.fileList.length; i++) {
                                let item = this.state.fileList[i];
                                if (item.uid) {//说明是刚上传的
                                    if (item.status != "done") {
                                        message.destroy()
                                        message.warn({content: `附件尚未上传完成！`});
                                        return;
                                    }
                                }
                            }
                            this.getReceiveUserDeptIds()
                            this.getPublish()
                        }}>发布</Button>
                    </div>
                }
            >
                <Scrollbars autoHeight autoHeightMax={650}>
                    <div style={{marginBottom: '20px', display: 'flex', alignItems: "flex-start"}}>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <span style={{color: "red"}}>*</span>标题:
                            <Input value={this.state.inputValue} style={{width: '492px', margin: '0 30px 0 6px',backgroundColor:'rgba(0, 80, 179, 0.04)'}}
                                   placeholder={"请输入标题"}
                                   onChange={(e) => {
                                       if (e.target.value && e.target.value.length > 255) {
                                           message.destroy()
                                           return message.warn("标题字数限制在255字以内!")
                                       }
                                       this.setState({inputValue: e.target.value.substring(0, 255)})
                                   }}
                            />
                        </div>
                        <div style={{display:'flex',alignItems:'center'}} className={'publishObj'}>
                            <span>发布对象:</span>
                            <Select value={this.state.typeValue} style={{width: "165px", margin: '0 6px'}}
                                    onSelect={(value) => {
                                        if (value === "users") {
                                            this.setState({isDisplay: "block", deptAndUserVisible: true}, () => {
                                                if(this.state.receiveUserDeptInfos && this.state.receiveUserDeptInfos.length){
                                                    this.state.data.receiveUserDeptInfos = [...this.state.receiveUserDeptInfos]
                                                }
                                                if (this.state.data.receiveUserDeptInfos) {
                                                    setTimeout(() => {
                                                        this.CandidateComponents && this.CandidateComponents.setCheckedKeys(this.state.data.receiveUserDeptInfos)
                                                    }, 0)
                                                }
                                            })
                                        } else if (value === "all") {
                                            this.setState({isDisplay: "none", selectList: '',})
                                        } else if (value === "depts") {
                                            this.setState({isDisplay: "block", deptVisible: true}, () => {
                                                setTimeout(() => {
                                                    this.treeModuleBySelectDept.setSelectList(this.state.receiveDeptInfos || []);
                                                }, 0);
                                            })
                                        }
                                        this.setState({typeValue: value})
                                    }}
                                    onChange={(value) => {
                                        // this.setState({typeValue: value})
                                    }}>
                                <Option value="all">全部</Option>
                                <Option value="users">指定个人</Option>
                                <Option value="depts">指定部门</Option>
                            </Select>
                        </div>
                        <Select className={'selectPublishObj'} style={{
                            marginLeft: '30px',
                            backgroundColor: 'rgba(0, 80, 179, 0.04)',
                            width: parseInt(document.body.clientWidth) > 1500 ? 300 : 200,
                            display: this.state.isDisplay,
                        }}
                                mode="multiple"
                                open={false}
                                value={that.state.typeValue === "depts" ? (that.state.receiveDeptInfos.map(item => {
                                    return item.name
                                })) : that.state.receiveUserDeptInfos.map(itemName => {
                                    return itemName.name + "(" + itemName.deptName + ")"
                                })}
                                onDeselect={(value) => {
                                    //删除确定列表中的数据
                                    that.state.receiveUserDeptInfos.map((itemName,index)=> {
                                        if(itemName.name + "(" + itemName.deptName + ")" == value){
                                            that.state.receiveUserDeptInfos.splice(index, 1);
                                        }
                                    })
                                    if (that.state.nameValue && that.state.nameValue) {
                                        this.state.data.receiveUserDeptInfos = [...that.state.receiveUserDeptInfos]
                                    }
                                    that.state.receiveUserDeptInfos = that.state.data.receiveUserDeptInfos && that.state.data.receiveUserDeptInfos.filter(itemName1 => that.state.nameValue.some(itemName2 => itemName1.name == itemName2))
                                    that.state.newSelectList = that.state.newSelectList && that.state.newSelectList.filter(itemId1 => that.state.receiveUserDeptInfos && that.state.receiveUserDeptInfos.some(itemId2 => itemId1 == itemId2.id))
                                    that.state.receiveUserDeptIds = that.state.data.receiveUserDeptInfos && that.state.data.receiveUserDeptInfos.filter(itemId1=>that.state.receiveUserDeptInfos && that.state.receiveUserDeptInfos.some(itemId2=> itemId1.key == itemId2.key))
                                    that.setState({});
                                }}
                                onDropdownVisibleChange={() => {
                                    if (this.state.typeValue === "depts") {
                                        this.setState({isDisplay: "block", deptVisible: true}, () => {
                                            setTimeout(() => {
                                                this.treeModuleBySelectDept.setSelectList(this.state.receiveDeptInfos || []);
                                            }, 0);
                                        })
                                    }
                                    if (this.state.typeValue === "users") {
                                        this.setState({isDisplay: "block", deptAndUserVisible: true}, () => {
                                            if (this.state.data && this.state.data.receiveUserDeptInfos) {
                                                if (this.state.receiveUserDeptInfos && this.state.receiveUserDeptInfos.length > 0) {
                                                    setTimeout(() => {
                                                        this.CandidateComponents && this.CandidateComponents.setCheckedKeys(this.state.receiveUserDeptInfos)
                                                    }, 0)
                                                } else if (this.state.receiveUserDeptInfos.length <= 0) {
                                                    setTimeout(() => {
                                                        this.CandidateComponents && this.CandidateComponents.setCheckedKeys(this.state.data.receiveUserDeptInfos)
                                                    }, 0)
                                                }
                                            } else if (this.state.nameValue && this.state.receiveUserDeptInfos) {
                                                setTimeout(() => {
                                                    this.CandidateComponents && this.CandidateComponents.setCheckedKeys(this.state.receiveUserDeptInfos)
                                                }, 0)
                                            }
                                        })
                                    }
                                }}
                        />
                        <style>
                            {`
                                .publishObj .ant-select .ant-select-selection{background-color:rgba(0, 80, 179, 0.04)}
                                .publishObj .ant-select-selection{background-color:rgba(0, 80, 179, 0.04)}
                                .selectPublishObj .ant-select-selection{height:50px;overflow-y:scroll;background-color:rgba(0, 80, 179, 0.04)}
                                .selectPublishObj .ant-select-selection::-webkit-scrollbar-thumb{border-radius:5px;background-color: rgb(0 0 0 / 20%);}
                                .selectPublishObj .ant-select-selection::-webkit-scrollbar-track{border-radius:0px}
                                .selectPublishObj .ant-select-selection::-webkit-scrollbar{width:6px}
                            `}
                        </style>
                    </div>
                    <Modal
                        maskClosable={false}
                        keyboard={true}
                        title="指定个人"
                        visible={this.state.deptAndUserVisible}
                        centered
                        key={uuid()}
                        width={800}
                        onOk={() => {
                            this.CandidateComponents.getSelectList((selectList) => {
                                //右侧搜索人名显示
                                selectList.forEach(item => item.hide = false);
                                this.state.receiveUserDeptInfos = selectList;
                                this.state.newSelectList = selectList.map(item => item.id);
                                this.state.nameValue = selectList.map(item => item.name);
                                this.state.userDeptIds = selectList.map((item) => item.key)
                                if (selectList.length > 0) {
                                    this.setState({deptAndUserVisible: false})
                                } else {
                                    message.destroy();
                                    message.warning("请选择人员");
                                }
                            })
                        }}
                        onCancel={() => {
                            if (this.state.data.receiveUserDeptInfos && this.state.data.receiveUserDeptInfos.length > 0 && this.state.receiveUserDeptInfos && this.state.receiveUserDeptInfos.length < 1) {
                                this.state.data.receiveUserDeptInfos.forEach(item => item.hide = false);
                            } else {
                                this.state.receiveUserDeptInfos && this.state.receiveUserDeptInfos.forEach(item => item.hide = false);
                            }
                            this.setState({deptAndUserVisible: false,})
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>
                            <CandidateComponents deptId={'0'} ref={(CandidateComponents) => {
                                this.CandidateComponents = CandidateComponents
                            }}/>
                        </div>
                    </Modal>
                    <Modal
                        maskClosable={false}
                        keyboard={true}
                        title="指定部门"
                        visible={this.state.deptVisible}
                        centered
                        key={uuid()}
                        width={800}
                        onOk={() => {
                            this.treeModuleBySelectDept.getSelectList((selectList) => {
                                if (selectList.length > 0) {
                                    // this.state.receiveDeptInfos=selectList.map(item=>item.id);
                                    this.setState({
                                        deptVisible: false,
                                        treeModuleBySelectDeptKey: uuid(),
                                        receiveDeptInfos: selectList
                                    }, () => {
                                        console.log("选部门确认回调========receiveDeptInfos=====", this.state.receiveDeptInfos)
                                    })
                                } else {
                                    message.destroy();
                                    message.warning("请选择部门");
                                }
                                //右侧搜索人名显示
                                // selectList.forEach(item=>item.hide=false);
                                // this.state.nameValue=selectList.map(item=>item.name);
                                // this.state.receiveUserDeptNames=selectList.map((item)=>item.deptName[0])
                                // this.state.receiveDeptInfos=selectList.map((item)=>item.key)
                            })
                        }}
                        onCancel={() => {
                            // if(this.state.data.receiveUserDeptInfos && this.state.data.receiveUserDeptInfos.length>0 && this.state.receiveUserDeptInfos && this.state.receiveUserDeptInfos.length < 1){
                            //     this.state.data.receiveUserDeptInfos.forEach(item=>item.hide=false);
                            // }else {
                            //     this.state.receiveUserDeptInfos.forEach(item=>item.hide=false);
                            // }
                            this.setState({deptVisible: false, treeModuleBySelectDeptKey: uuid()})
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>
                            <TreeModuleBySelectDept key={this.state.treeModuleBySelectDeptKey} deptId={'0'}
                                                    ref={(treeModuleBySelectDept) => {
                                                        this.treeModuleBySelectDept = treeModuleBySelectDept
                                                    }}/>
                        </div>
                    </Modal>
                    <div style={{marginBottom: "10px", display: "flex", width: 500}}>
                        <div style={{width: 85, height: 32, lineHeight: "32px"}}>公告附件</div>
                        <div style={{width: 500}}>
                            <NoticeUploadWall
                                ref={NoticeUploadWall => {
                                    this.NoticeUploadWall = NoticeUploadWall
                                }}
                                setFillList={this.state.fileList}
                            />
                        </div>

                    </div>
                    <div style={{paddingRight: '10px'}}>
                        <Editors
                            customHeight={500}
                            content={this.state.content}
                            isUpDate={this.state.isUpDate}
                            callBackeditorContent={(content) => {
                                this.setState({content, isUpDate: false})
                            }}
                        />
                    </div>
                </Scrollbars>
            </Modal>
        )
    }

    getReceiveUserDeptIds = () => {
        let newIds = []
        if (this.state.userIdAndDeptIds && this.state.userIdAndDeptIds.length) {
            newIds = this.state.userIdAndDeptIds.map(item => {
                return item.deptId + '-' + item.userId
            })
            this.state.receiveUserDeptIds&&this.state.receiveUserDeptIds.length?
                this.state.receiveUserDeptIds = newIds.filter(item1=>this.state.receiveUserDeptIds.some(item2=>item1==item2.key)):
                this.state.receiveUserDeptIds = newIds
        }
        if(this.state.userDeptIds && this.state.userDeptIds.length){
            this.state.receiveUserDeptIds = [...this.state.userDeptIds]
        }
    }

    getSave = (params) => {
        this.request({
            url: '/cm-sites-sys/notice/save',
            method: "post",
            body: params,
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    if (params.notice && params.notice.status == 3) {
                        message.destroy()
                        message.success('发布成功')
                    } else {
                        message.destroy()
                        message.success('暂存成功')
                    }
                    this.handleCancel()
                    this.props.getList()
                }
            }
        });
    }

    checkParams = () => {
        let {inputValue, content} = this.state;
        if (!inputValue) {
            message.destroy()
            message.warn("请输入标题！");
            return false;
        }
        if (!content.replace(/(<(?!img|IMG).*?>)|(&nbsp;)|(\s)/g, "")) {
            message.destroy()
            message.warn("请输入文章内容！");
            return false;
        }
        return true;
    };
}